export default __webpack_public_path__ + "static/media/ISEO CLASS-5 EXAM PATTERN 2026-27.4a1d380a.pdf";